import axios from 'axios'
import messageMixin from '@/mixin/messageMixin'
import router from '@/router/index'

export default ({
  namespaced: true,
  mixins: [messageMixin],

  state: {
    user: null,
  },

  getters: {
    user (state) {
      return state.user
    },
  },

  mutations: {
    SET_USER (state, user) {
      state.user = user
    },
  },

  actions: {

  }

})
